import { render, staticRenderFns } from "./Fader.vue?vue&type=template&id=33802b36&"
import script from "./Fader.vue?vue&type=script&lang=js&"
export * from "./Fader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports